import api from "@/axios";
import config from "~/config";

export default {
  GET: {
    MANAGED_OFFERS: async () => {
      const { data } = await api.get(`${config.NEW_ORG_URL}/managedoffers`);
      return data.offers;
    },
  },
  POST: {
    SEARCH: async (query) => {
      const { data } = await api.post(`${config.NEW_ORG_URL}/managedoffers`, {
        searchString: query,
      });
      return data.items;
    },
    ADD_ACCOUNT_OFFER: async (payload) => {
      const { data } = await api.post(
        `${config.NEW_ORG_URL}/accountoffers`,
        payload,
      );
      return data;
    },
  },
  PUT: {
    UPDATE_ACCOUNT_OFFER: async (payload) => {
      const { data } = await api.put(
        `${config.NEW_ORG_URL}/accountoffers`,
        payload,
      );
      return data;
    },
  },
  DELETE: {
    DELETE_ACCOUNT_OFFER: async (payload) => {
      const { data } = await api.delete(`${config.NEW_ORG_URL}/accountoffers`, {
        data: payload,
      });
      return data;
    },
  },
  PATCH: {},
};
